import { DetentionControl } from "../DetentionControl";
import { OrderDuplicateControl } from "../OrderDuplicateControl";
import { DataHeader, DataSource, Layout, Panel, Switch, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOrderControl extends Layout {
    dataheaderOrderControl: DataHeader;
    layoutDetentionControl: DetentionControl;
    layoutDuplicateControl: OrderDuplicateControl;
    panelBOL: Panel;
    panelBatchOrderControl: Panel;
    panelCreditLimits: Panel;
    panelDuplicateControl: Panel;
    panelOrderColumn1: Panel;
    panelOrderColumn2: Panel;
    panelOrderColumn3: Panel;
    panelOrderMiscellaneous: Panel;
    panelQuotes: Panel;
    panelSwitches: Panel;
    sourceCopyControl: DataSource;
    sourceDetentionControl: DataSource;
    sourceDispatchControl: DataSource;
    switchAllowBatchOrderEntry: Switch;
    switchAppointmentConf: Switch;
    switchAutoRateOrders: Switch;
    switchBOLReceived: Switch;
    switchBatchCreateEmpties: Switch;
    switchCalculateDistance: Switch;
    switchCreditLimitOverrides: Switch;
    switchEnforceBillTo: Switch;
    switchEnforceCommentsVoidOrders: Switch;
    switchEnforceRevenueCode: Switch;
    switchEnforceShipperCode: Switch;
    switchEnterRecOrderID: Switch;
    switchEquipmentMatch: Switch;
    switchEstimateFuelSurcharge: Switch;
    switchImplementDimensionSurcharges: Switch;
    switchPreventDispatchOrderOnHold: Switch;
    tabBOL: Tab;
    tabBatchOrder: Tab;
    tabCreditLimits: Tab;
    tabDetention: Tab;
    tabDuplicateControl: Tab;
    tabGeneral: Tab;
    tabQuotes: Tab;
    tabsetControlGroups: Tabset;
    textboxAssignModeBy: Textbox;
    textboxBreadcrumbInterval: Textbox;
    textboxCheckDuplicateBOL: Textbox;
    textboxCreditLimitWarningPercent: Textbox;
    textboxDataFusionRevenueCode: Textbox;
    textboxDaysToExpiration: Textbox;
    textboxDefaultQuoteStatus: Textbox;
    textboxDeliveryReceiptFormat: Textbox;
    textboxDuplicateBOLWarningLevel: Textbox;
    textboxEnforceCustomerCreditLimits: Textbox;
    textboxMode: Textbox;
    textboxSetPointControl: Textbox;
}
